import { render } from "./ReferenceCardsList.vue?vue&type=template&id=66f4c15a&scoped=true"
import script from "./ReferenceCardsList.vue?vue&type=script&lang=js"
export * from "./ReferenceCardsList.vue?vue&type=script&lang=js"

import "./ReferenceCardsList.vue?vue&type=style&index=0&id=66f4c15a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f4c15a"]])

export default __exports__